export function videoLightbox() {
    (function() {
        /**
         * Video Lightbox
         * Plays a YouTube, Vimeo or Facebook video in a single shared modal.
         *
         * Opt in on any button or link with `data-video-lightbox` set to the
         * video's page URL — the kind you get from the address bar or a Share
         * dialog. Already-built embed URLs are accepted too. Optional:
         *   data-video-title   — accessible name for the player
         *   data-video-caption — caption shown under the player
         *
         * The iframe is created on open and destroyed on close, which is what
         * actually stops playback — every provider keeps playing if you only
         * hide the modal.
         */
        const modalEl = document.getElementById('videoLightbox');
        if (!modalEl) return;

        const modal = new bootstrap.Modal(modalEl);
        const $frame = $(modalEl).find('.video-lightbox-frame');
        const $caption = $(modalEl).find('.lightbox-caption');
        const $label = $(modalEl).find('#videoLightboxLabel');

        // Bootstrap only restores focus for modals opened via data-bs-toggle,
        // so we track the trigger and send the keyboard back there on close
        let $lastTrigger = null;

        /**
         * Read a YouTube timestamp. Short links share as `t=90` but also as
         * `t=1m30s`, which parseInt would silently read as 1 second.
         */
        function toSeconds(value) {
            if (/^\d+$/.test(value)) return Number(value);
            const parts = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
            if (!parts) return 0;
            return (Number(parts[1] || 0) * 3600)
                + (Number(parts[2] || 0) * 60)
                + Number(parts[3] || 0);
        }

        /**
         * Turn a shared video URL into an embeddable player URL.
         * Returns null when the host isn't one we support, so the caller can
         * leave the click alone and let a normal link navigate.
         */
        function toEmbedUrl(raw) {
            let url;
            try {
                url = new URL(raw, window.location.href);
            } catch (err) {
                return null;
            }

            const host = url.hostname.replace(/^www\./, '');
            const path = url.pathname;

            // YouTube — youtu.be/ID, /watch?v=ID, /embed/ID, /shorts/ID, /live/ID
            if (host === 'youtu.be' || host.endsWith('youtube.com') || host.endsWith('youtube-nocookie.com')) {
                let id = url.searchParams.get('v');
                if (!id) {
                    const match = path.match(/^\/(?:embed|shorts|live|v)\/([^/?#]+)/);
                    id = match ? match[1] : (host === 'youtu.be' ? path.split('/')[1] : '');
                }
                if (!id) return null;

                const params = new URLSearchParams({ rel: '0', autoplay: '1', playsinline: '1' });
                const start = url.searchParams.get('t') || url.searchParams.get('start');
                if (start) params.set('start', toSeconds(start));
                return 'https://www.youtube.com/embed/' + id + '?' + params;
            }

            // Vimeo — vimeo.com/ID, vimeo.com/ID/HASH (unlisted), player.vimeo.com/video/ID
            if (host.endsWith('vimeo.com')) {
                const match = path.match(/\/(?:video\/)?(\d+)(?:\/([0-9a-zA-Z]+))?/);
                if (!match) return null;

                const params = new URLSearchParams({ autoplay: '1' });
                const hash = match[2] || url.searchParams.get('h');
                if (hash) params.set('h', hash);
                return 'https://player.vimeo.com/video/' + match[1] + '?' + params;
            }

            // Facebook — the video plugin takes the video's page URL as a
            // parameter rather than an id, so hand it whichever URL we were
            // given (or the one already inside an existing embed).
            if (host.endsWith('facebook.com') || host === 'fb.watch') {
                const href = path === '/plugins/video.php'
                    ? url.searchParams.get('href')
                    : url.href;
                if (!href) return null;

                const params = new URLSearchParams({ href: href, show_text: '0', autoplay: 'true' });
                return 'https://www.facebook.com/plugins/video.php?' + params;
            }

            return null;
        }

        // Delegated so triggers inside carousels and other cloned markup work
        $(document).on('click', '[data-video-lightbox]', function(event) {
            const $trigger = $(this);
            const source = $trigger.attr('data-video-lightbox') || $trigger.attr('href') || '';
            const embedUrl = toEmbedUrl(source);

            // Unrecognized host — let an <a> navigate the way it normally would
            if (!embedUrl) return;

            event.preventDefault();

            const title = ($trigger.attr('data-video-title')
                || $trigger.attr('aria-label')
                || 'Video player').trim();
            const caption = ($trigger.attr('data-video-caption') || '').trim();

            $frame.empty().append($('<iframe>', {
                src: embedUrl,
                title: title,
                frameborder: '0',
                allow: 'autoplay; fullscreen; picture-in-picture; encrypted-media',
                allowfullscreen: 'allowfullscreen'
            }));

            $label.text(title);
            $caption.text(caption).toggle(caption.length > 0);
            $lastTrigger = $trigger;
            modal.show();
        });

        modalEl.addEventListener('hidden.bs.modal', function() {
            // Removing the iframe is what stops playback — hiding it isn't enough
            $frame.empty();

            if ($lastTrigger && $lastTrigger.is(':visible')) {
                $lastTrigger.trigger('focus');
            }
            $lastTrigger = null;
        });
    })();
}
